import { render, staticRenderFns } from "./LootNotif.vue?vue&type=template&id=fd54ab6a&"
import script from "./LootNotif.vue?vue&type=script&lang=js&"
export * from "./LootNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports